import axios from 'axios'

const baseURL = 'https://mastsuya-api.onrender.com'

const api = axios.create({
  baseURL,
});

export default api;
